
import Header from '@/components/taxi/core/Header';
import Footer from '@/components/taxi/core/Footer';
export default {
  components: {
    Header,
    Footer
  },
  head() {
      return {
      link: [
        {
          hid: 'canonical',
          rel: 'canonical',
          href: 'https://www.goa.app' + this.$route.path
        }
      ],
        bodyAttrs: {
          class: 'pb-0'
        }
      }
    },
  data() {
    return {
      title: null,
    }
  },
  methods: {
    getTitle(value) {
      this.title = value;
    }
  }
}

